import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { MdDialog } from '@angular/material';
import { SliderMapCvComponent } from '../slider-map-cv/slider-map-cv.component';
import { CvMapComponent } from '../cv-map/cv-map.component';
import { ApplicantFilter } from '../../interfaces/filters';
import { JobsOffersApplicant } from '../../models/jobs-offers-applicant';
import { Profile } from '../../models/profile';
import { Observable } from 'rxjs/Observable';
import { InviteService } from '../../services/invite.service';
import { Invite } from '../../models/invite'
import { JobSelectorDialogComponent } from '../job-selector-dialog/job-selector-dialog.component'
import { MessageBoxDialog } from '../message-box/message-box.component';
import { MessageBoxInviteDialog } from '../message-box-invite/message-box-invite.component';
import { ProfileNoLocationStore } from '../state/profile-no-location.store';

@Component({
  selector: 'app-list-candidates-map',
  templateUrl: './list-candidates-map.component.html',
  styleUrls: ['./list-candidates-map.component.css']
})
export class ListCandidatesMapComponent implements OnChanges {

  @Input() applicantFilter: ApplicantFilter;
  @Input() requirement: boolean;

  maxCandidates: number = 10;
  errorMessage: string;
  loading: Observable<boolean>;
  size: Observable<number>;
  total: Observable<number>;

  premium:string;

  constructor(private dialog: MdDialog,
              public profileNoLocationStore: ProfileNoLocationStore,
              private inviteService:InviteService) {


  }

  ngOnInit() {
    if (localStorage.getItem('premium')){
      this.premium = localStorage.getItem('premium');
    } else {
      this.premium = '0';
    }
    this.profileNoLocationStore.restore();
    this.loading = this.profileNoLocationStore.loading.share();
    this.size = this.profileNoLocationStore.profiles.map((profiles: Profile[]) => profiles.length);
    this.total = this.profileNoLocationStore.getTotal;
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      if(propName === 'requirement') {
        let chng = changes[propName];
        if(chng.previousValue != chng.currentValue) {
           this.refreshListing(1);
        }
      }
    }
  }

  refreshListing(page: number) {
    this.profileNoLocationStore.changeFilters(this.applicantFilter,page,10);
  }

  openCV(selectedIndex) {
    this.dialog.open(SliderMapCvComponent, {
      data: {selected: selectedIndex, map:false, filters: this.applicantFilter}
    });
  }

  onInvite(userId) {
    // if (this.jobId != undefined) {
    //   this.onPostInviteById(userId);
    // } else {
      this.openDialogJobSelectorDialog(userId);
  //  }
  }

  openDialogJobSelectorDialog(userId) {
    let dialogRef = this.dialog.open(JobSelectorDialogComponent);
    dialogRef.componentInstance.createInvite=true;
    dialogRef.componentInstance.UserID=userId;
    dialogRef.componentInstance.nameComponent='Invitación';
    dialogRef.componentInstance.hv='0';

    dialogRef.afterClosed().subscribe(result => {
      if (result != "YES") {
        // this.dialog.open(MessageBoxDialog, {data: {message: 'Invitación Enviada', success: true, showIcon:true}});
      }
    });
  }

  onPostInviteById(id) {
    let invitations = [{
        "user_id":id
    }];

    this.inviteService.postInvite(invitations)
      .subscribe(
        data => {
          this.dialog.open(MessageBoxInviteDialog, {data: {data: data, success: true, showIcon:true}});
        },
        error => {
          this.dialog.open(MessageBoxDialog, {data: {title: 'Información Dreamjobs', message: error.message, alert: true, showIcon: true}});
        }
      );
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/list-candidates-map/list-candidates-map.component.ts